import { object, string } from 'yup';

// The backend caps an address at RFC 5321's 254 octets and rejects anything
// longer with a 400 (TA-10679). yup's `.email()` has no length bound, so
// without this the field accepts an address the API will refuse — and the
// forgot-password flow would confirm a reset it never sent.
const MAX_EMAIL_LENGTH = 254;

const authSchema = object({
  // `.trim()` first, so `.email()` and `.max()` both judge the trimmed value.
  // Without it a pasted address with a leading or trailing space is rejected
  // outright — yup's `.email()` fails on the whitespace — even though the
  // address is fine and the backend strips before it validates.
  //
  // yup's trim is a cast, not a write-back: Formik's `values.email` keeps the
  // space, so every send site normalises too rather than relying on this.
  email: string()
    .trim()
    .email('Invalid email address')
    .max(MAX_EMAIL_LENGTH, 'Invalid email address')
    .required('Required'),
  password: string().required('Required'),
});

export default authSchema;
